import h from 'hyperscript';
import { unByKey } from 'ol/Observable';
import 'ui/alert/alert';
import 'ui/switch/switch';
import { SourceProperty } from 'cadenza/map/source-property';

import i18n from '../messages.properties';

import './legend-layer-tasks';
import './legend-layer.css';

const NAME = 'd-legend-layer-alerts';

export class LegendLayerAlerts extends HTMLElement {

  #layer;
  #map;
  #alerts;

  constructor (layer, map) {
    super();
    this.#layer = layer;
    this.#map = map;

    this.classList.add(NAME);
    this.#alerts = h('d-alerts', { compactMessages: true });
    this.append(this.#alerts);
  }

  connectedCallback () {
    const source = this.#layer.getSource();
    this._eventKeys = [
      source.on(`change:${SourceProperty.MESSAGES}`, () => {
        this.#alerts.alerts = source.get(SourceProperty.MESSAGES).map(message => apiMessageToAlert(message));
      })
    ];
  }

  disconnectedCallback () {
    unByKey(this._eventKeys);
  }

}

customElements.define(NAME, LegendLayerAlerts);

const MESSAGE_TYPE_MAPPING = {
  'ERROR': 'error',
  'WARNING': 'warning',
  'INFO': 'info'
};
const DEFAULT_MESSAGE_TYPE = MESSAGE_TYPE_MAPPING.INFO;

function apiMessageToAlert (apiMessage) {
  const title = i18n(`${apiMessage.code}.title`, apiMessage.args);
  const message = i18n(`${apiMessage.code}.text`, apiMessage.args);
  const type = MESSAGE_TYPE_MAPPING[apiMessage.type] || DEFAULT_MESSAGE_TYPE;

  return { type, title, message };
}
